'use client';

import React, { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import classes from './AdminShell.module.scss';

type AdminShellProps = {
  children: ReactNode;
  lang?: string;
};

/**
 * Static shell for the whole back-office: light neumorphic background on
 * regular admin pages, deep navy with a subtle glow on Jarvis pages.
 * The video background was removed — it added weight and no value.
 */
export function AdminShell({ children }: AdminShellProps) {
  const pathname = usePathname();
  const isJarvisPage = pathname?.includes('/jarvis') ?? false;
  const isPublishPage = pathname?.includes('/jarvis/publish') ?? false;

  return (
    <div className={classes.root}>
      <div
        className={`${classes.bg} ${isJarvisPage ? classes.bgJarvis : ''} ${isPublishPage ? classes.bgPublish : ''}`}
      >
        {isJarvisPage && (
          <div
            className={`${classes.jarvisGlowMask} ${isPublishPage ? classes.jarvisGlowMaskPublish : ''}`}
            aria-hidden="true"
          />
        )}
        {isPublishPage && <div className={classes.bgVignettePublish} aria-hidden="true" />}
      </div>

      <div className={classes.page}>{children}</div>
    </div>
  );
}
